export const serviceList = [
  // 工作台
  {
    menuId: '647389766177800192',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '工作台',
    menuUrl: 'mainCenter',
    menuIcon: '647389653497806849',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 运营端 - 数据概览
      {
        menuId: '6473904716242955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '数据概览',
        menuUrl: 'serviceIndex',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: []
      }
    ]
  },
  // 课程中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '课程中心',
    menuUrl: 'courseCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 课程中心 - 商品管理
      {
        menuId: '64739047164955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '商品管理',
        menuUrl: 'commodity',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 商品管理 - 课程商品
          {
            menuId: '64739047142955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程商品',
            menuUrl: 'courseCenter_commodity_commodityTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 商品管理-材料管理
          {
            menuId: '64739047142955793',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '材料管理',
            menuUrl: 'courseCenter_commodity_materialTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 2,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 课程中心 - 资源管理
      {
        menuId: '1647390471642955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '资源管理',
        menuUrl: 'resources',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 资源管理 - 课程资源
          {
            menuId: '64730471642955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程资源',
            menuUrl: 'courseCenter_resources_courseTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 排课中心
  // 排课中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '排课中心',
    menuUrl: 'courseSchedulCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 分班管理
      {
        menuId: '647SDS955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '分班管理',
        menuUrl: 'divideClassManage',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 分班管理 - 分班管理
          {
            menuId: '6473932320471645777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '分班管理',
            menuUrl: 'courseSchedulCenter_divideClassManage_list',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 分班管理 - 已删除班级
          {
            menuId: '4234375475489439874345',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '已删除班级',
            menuUrl: 'courseSchedulCenter_divideClassManage_deleteClassList',
            menuIcon: '423423437865435423',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 订单中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '订单中心',
    menuUrl: 'orderCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 订单管理 - 订单管理
      {
        menuId: 'DSD971642955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '订单管理',
        menuUrl: 'order',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '647347164A7',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程订单',
            menuUrl: 'orderCenter_order_orderTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '6473471642C',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程套餐订单',
            menuUrl: 'orderCenter_order_comboIndex',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',

            childList: []
          },
          {
            menuId: '6473471643A',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '材料费订单',
            menuUrl: 'orderCenter_order_materialIndex',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 订单管理 - 售后管理
      {
        menuId: '769876986598',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '售后管理',
        menuUrl: 'afterSale',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '6955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '退款管理',
            menuUrl: 'orderCenter_afterSale_schCourseRefund',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 财务中心
  {
    menuId: '658618431720919150',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '财务中心',
    menuUrl: 'financeCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 订单管理 - 订单管理
      {
        menuId: 'FSD971642955888',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '结算单管理',
        menuUrl: 'settlement',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '45876897698A',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '结算账单',
            menuUrl: 'financeCenter_settlement_org',
            menuIcon: '5135415431',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '52364356426',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 教务中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '教务中心',
    menuUrl: 'eduCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 教务中心 - 消息管理 - 公共
      {
        menuId: '324324',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '消息管理',
        menuUrl: 'message',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '6473904sdasd6429777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '消息管理',
            menuUrl: 'eduCenter_message_list',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
          // {
          //   menuId: '6sdd739046429777',
          //   domainCode: 'zhxy-cloud',
          //   appCode: 'basic430hon',
          //   typeCode: '$default',
          //   menuName: '待办审批',
          //   menuUrl: 'eduCenter_message_pending',
          //   menuIcon: '647390423244865536',
          //   openWay: 1,
          //   accessFlag: 1,
          //   parentMenuId: '647390246509494273',
          //   sort: 1,
          //   status: null,
          //   extra: '',
          //   childList: []
          // }
        ]
      },
      // 教务中心 - 教师考勤
      // 教务中心 - 教师考勤
      {
        menuId: '3335654354331d',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '教师考勤',
        menuUrl: 'schoolAttendance',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '334423684354554651',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤汇总',
            menuUrl: 'eduCenter_schoolAttendance_collectAll',
            menuIcon: '657688985434345',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '654645645643643445',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '3343254354554651',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤明细',
            menuUrl: 'eduCenter_schoolAttendance_index',
            menuIcon: '425436548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '336435643653331d',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '3343254354554534asda651',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤汇总(按月)',
            menuUrl: 'eduCenter_schoolAttendance_collect',
            menuIcon: '425436548789985434345',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '53453453453',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 教务中心 - 学生考勤
      {
        menuId: '33331d',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '学生考勤',
        menuUrl: 'studentAttance',
        menuIcon: '435435435654336777',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '4343254354554654',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学生考勤',
            menuUrl: 'eduCenter_studentAttance_Index',
            menuIcon: '425436548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '77763453321412',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 教务中心 - 学生请假 - 学生请假
      {
        menuId: '64739234324234046429777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '请假管理',
        menuUrl: 'askLeave',
        menuIcon: '425436548789985434343',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '77763453321412',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '4343254354554654',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学生请假',
            menuUrl: 'eduCenter_askLeave_Index',
            menuIcon: '425436548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '77763453321412',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '8768678342254354554654',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师请假',
            menuUrl: 'eduCenter_askLeave_TeacherIndex',
            menuIcon: '967567548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '77763453321412',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      {
        menuId: '311551232983',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '平台服务',
        menuUrl: 'platform',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '647390546454399a1',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务协议管理',
            menuUrl: 'eduCenter_platform_agreementManage',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '64739054645439999',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务签约记录',
            menuUrl: 'eduCenter_platform_orgsigning',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 基础信息中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '基础信息中心',
    menuUrl: 'basicInfoCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 基础信息中心 - 服务机构
      {
        menuId: 'aLKlr1skdja',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '服务机构',
        menuUrl: 'service',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: 'asUIYNflk',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务信息',
            menuUrl: 'basicInfoCenter_service_personnel',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: 'ds213dd',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '机构教师',
            menuUrl: 'basicInfoCenter_service_teacherList',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  }
];
